export function videoPopup() {
    let popup = $(".video-popup");
    let videoHolder = popup.find(".video-popup-holder");
    $(".video-popup-opener").on("click", function () {
        let $this = $(this);
        let src = $this.data("src");
        if ($this.hasClass("not-vimeo")) {
            let video = $("<video />", {
                src: src,
                type: "video/mp4",
                controls: true
            });
            video.appendTo(videoHolder);
            video[0].load();
            setTimeout(function () {
                video[0].play();
            }, 400);
        } else {
            $("<iframe>", {
                src: src + "&amp;dnt=1&amp;app_id=122963&amp;autoplay=1&autopause=0&amp;title=0&amp;sidedock=0&amp;",
                frameborder: 0,
                allow: "autoplay",
                fullscreen: true,
                allowfullscreen: true,
                scrolling: "no"
            }).appendTo(videoHolder);
        }
        setTimeout(function () {
            popup.addClass("show");
        }, 500);
    });
    popup.find(".close").on("click", function () {
        popup.removeClass("show");
        setTimeout(function () {
            videoHolder.children().remove();
        }, 500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/videoPopup.js